import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3afvbgndq: FaireProductEntity = {
  token: "p_b3afvbgndq",
  type: "product",
  name: "Queens Gochujang",
  brandToken: "b_sjfjb7psuq",
  brandName: "Queens",
  imageUrl:
    "https://cdn.faire.com/fastly/198bdfbf446d3acb5b3cb79dbdbf45089e72664cf9662f67f1e61fb1dc97a3b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c0481f01b3c7e7f883be34b3799332cd107c13f0f31273a1750b97d9b24287c.jpeg",
    "https://cdn.faire.com/fastly/a101ee50cad5686b681cdbd8bc19e1700cb81fa69b568d7921ee2a6b663d463f.jpeg",
    "https://cdn.faire.com/fastly/2afd5c486e699fc020c3c588ababd23f2abcc6dff68ff804b03ad10b6d82d454.png",
  ],
  priceDollars: 9,
  description:
    "Gochujang is a traditional fermented red chili paste condiment that is made with dried Korean Hong Gochu chili peppers, lacto-fermented soybeans, and sea salt. Our Gochujang features peak season, hand-picked dried jujubes that lend a sweet, caramel-like flavor and a hint of earthiness to balance the spice. It is left to ferment for 90 days where its flavors mellow out and become gentler over time. Left in a cool area away from sun exposure, Gochujang keeps indefinitely and matures beautifully, amplifying its sweetness and luscious texture. \n\nCreative uses: An excellent base flavor to build and layer with, like in marinades, dressings, and stews. Add it to any sauce that needs a little heat or earthiness, even meatiness. Use it to introduce more umami into a dish or as a natural thickening agent for soups. Makes the foundation for our Chojang (spicy gochujang vinaigrette) and is elemental in other Korean dishes like ddeokbokki (spicy stir fried rice cakes) & kimchi jjigae (kimchi stew).",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:29.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
